import React, { useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { FaInfoCircle } from 'react-icons/fa'
import { Tooltip } from 'reactstrap'

// Define global styles for the custom tooltip
const TooltipMaxWidth = createGlobalStyle`
  .route-stats-tooltip .tooltip-inner {
    max-width: 20rem; // Set max-width using relative units
    white-space: normal; // Allow text wrapping
    text-align: left; // Adjust text alignment if needed
  }
`

const CardWrapper = styled.div`
  overflow: hidden;
  border-radius: 12px;
  background-color: ${props => props.theme.dashboard.cardBackground};
  ${({ containerStyles }) => (containerStyles ? containerStyles : '')}
  display: flex;
  flex-direction: column;
`

const StatTitleContainer = styled.div`
  background-color: ${props => props.theme.dashboard.cardHeaderBackground};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.5rem 0;
`

const StatTitle = styled.h2`
  color: ${props => props.theme.dashboard.cardTitle};
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
`

const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  padding: 1rem;
`

const TitleWithIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const InfoIcon = styled(FaInfoCircle)`
  cursor: pointer;
  color: ${props => props.theme.dashboard.metricTitle || '#ADADAD'};
  margin-left: 0.5em;
  display: inline-block;
`

const StatCard = ({
  title,
  children,
  containerStyles,
  faqComponent,
  tooltipText
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen)

  const iconId = `tooltip-icon-${title
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')}`

  const shouldShowIcon = !!tooltipText

  return (
    <CardWrapper containerStyles={containerStyles}>
      {/* Render the global style component */}
      <TooltipMaxWidth />
      <StatTitleContainer>
        <TitleWithIconContainer>
          <StatTitle>
            {title}
            {faqComponent}
          </StatTitle>
          {shouldShowIcon && (
            <>
              <InfoIcon id={iconId} size={'1em'} />
              <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={iconId}
                toggle={toggleTooltip}
                className="route-stats-tooltip"
              >
                {tooltipText}
              </Tooltip>
            </>
          )}
        </TitleWithIconContainer>
      </StatTitleContainer>
      <StatContent>{children}</StatContent>
    </CardWrapper>
  )
}

export default StatCard
